import * as PropTypes from 'prop-types';
import Layout from 'antd/lib/layout';
import Menu from 'antd/lib/menu';
import { LogoutOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import { useFela } from 'react-fela';

import Logo from '../Logo';
import LanguageSwitcher from '../../containers/LanguageSwitcher';

import rule from './Header.rule';

const AntHeader = Layout.Header;

const Items = {
    LOGOUT: 'logout',
    LANGUAGES: 'languages',
};

const Header = ({ handleLogout }) => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <AntHeader>
                <Logo />
                <Menu theme="dark" mode="horizontal">
                    <Menu.Item key={Items.LANGUAGES}>
                        <LanguageSwitcher />
                    </Menu.Item>
                    <Menu.Item
                        key={Items.LOGOUT}
                        onClick={() => {
                            handleLogout();
                        }}
                    >
                        <LogoutOutlined /> <FormattedMessage id="header.logout" />
                    </Menu.Item>
                </Menu>
            </AntHeader>
        </div>
    );
};

Header.propTypes = {
    handleLogout: PropTypes.func.isRequired,
};

export default Header;
